import type { ReactNode } from 'react';
import type {
  MerchantCreativeRunView,
  MerchantProfileView,
} from '../../merchant/api.js';
import { contentLanguage, researchUi } from './researchPresentation.js';

/** Display only the direction bound to this persisted creative run. */
export function SelectedDirectionSummary({
  view,
  run,
  language,
}: {
  readonly view: MerchantProfileView | null;
  readonly run: MerchantCreativeRunView | null;
  readonly language: 'en' | 'ar';
}): ReactNode {
  const idea = view?.result?.recommendations.find(
    (item) => item.artifactId === run?.directionArtifactId,
  );
  if (idea === undefined) return null;
  return (
    <div className="mj-ws-selected-direction mj-ws-mt-20">
      <span className="mj-ws-muted mj-ws-xs">
        {language === 'ar' ? 'الفكرة المختارة' : 'Selected idea'}
      </span>
      <p className="mj-ws-strong" dir="auto">
        {idea.title}
      </p>
      <p className="mj-ws-sm" dir="auto">
        {idea.objective}
      </p>
      <p className="mj-ws-muted mj-ws-xs">
        {researchUi[language].content}: {contentLanguage(idea.outputLocale, language)}
      </p>
    </div>
  );
}
